import axios from 'axios';
import store from 'store';
// import Swal from 'sweetalert2';
import moment from 'moment';
import { DataTable } from 'simple-datatables';

import authHelper from './helpers/authHelper.js';
import { addDNoneClass, btnLoading, byId, Toast } from './helpers/utility.js';
import { axiosErrorHandler, axiosResponseHandler, callTheBaseServerGet, callTheBaseServerPost } from './helpers/axiosHelper.js';
authHelper.validate().then(async () => {



    const data_table_body = byId('data_table_body');
    const insert_div = byId('insert_div');
    const init_div = byId('init_div');
    const company_name_input = byId('company_name');
    const category_input = byId('category');
    const message_input = byId('message');
    const buy_price_input = byId('buy_price');
    const sl_price_input = byId('sl_price');


    // const insert_btn = byId('insert_btn');
    // let init_btn = byId('init_btn');



    const advisoryPageFun = {
        insert: {
            init: (status) => {
                status ? addDNoneClass(insert_div, false) : addDNoneClass(insert_div, true);
                status ? addDNoneClass(init_div, true) : addDNoneClass(init_div, false);

            },
            submit: async () => {
                try {
                    const data = {
                        companyName: company_name_input.value,
                        message: message_input.value,
                        category: category_input.value,
                        buyPrice: buy_price_input.value,
                        slPrice: sl_price_input.value

                    };

                    const response = await callTheBaseServerPost('/basic/insertAdvisoryData', { data });
                    axiosResponseHandler(response);
                    const res = response.data;
                    if (res.status === 'success') {
                        console.log(res);

                        Toast.fire({
                            icon: 'success',
                            title: res.msg
                        });
                        location.reload();
                    }


                } catch (error) {
                    axiosErrorHandler(error);
                }
            }
        },
        fetch: async () => {
            try {

                const response = await callTheBaseServerGet('/basic/getAdvisoryData');
                axiosResponseHandler(response);
                const res = response.data;
                if (res.status === 'success') {
                    console.log(res);
                    const { advisoryData } = res;

                    if (advisoryData.length > 0) {

                        for (let i = 0; i < advisoryData.length; i++) {

                            const { sn, companyName, message, category, buyPrice, slPrice,createdAt } = advisoryData[i];
                            // let   init_data = res.res_data[i]
                            const time = moment(createdAt * 1000).startOf().fromNow();
                            if(i===0){
                                data_table_body.innerHTML ='';  
                            }
                            data_table_body.innerHTML += ` 
                                    <tr>
                                           <th scope="row">${sn}</th>
                                        <td>${companyName}</td>
                                        <td>${category}</td>
                                        <td>${message}</td>
                                        <td>${buyPrice}</td>
                                        <td>${slPrice}</td>
                                        <td>${time}</td>
                                      
                                     
                                    
                                        <td> <button id="d${sn}" onclick="advisoryPageFun.delete(${sn})" class="btn btn-danger ">Delete</button> </td>
                                   </tr>`;

                        }
                    }

                    // Initiate Datatables


                    // eslint-disable-next-line no-unused-vars
                    const simpleDatatables = new DataTable('#data_table', {
                        // searchable: false,
                        // perPageSelect: false, 


                    });
                }


            } catch (error) {
                axiosErrorHandler(error);
            }
        },
        delete: async (sn) => {
            try {

                const response = await callTheBaseServerGet(`/basic/deleteAdvisoryData/${sn}`);
                axiosResponseHandler(response);
                const res = response.data;
                if (res.status === 'success') {
                    console.log(res);

                    Toast.fire({
                        icon: 'success',
                        title: res.msg
                    });
                    location.reload();
              
                }


            } catch (error) {
                axiosErrorHandler(error);
            }
        }

    };

    window.advisoryPageFun = advisoryPageFun;

    advisoryPageFun.fetch();





});












// inserting advisory
function insert_advisory() {
    btnLoading(insert_btn, 'Loading...', true);
    var bodyFormData = new URLSearchParams();
    bodyFormData.append('company_name', company_name_input.value);
    bodyFormData.append('category', category_input.value);
    bodyFormData.append('message', message_input.value);
    bodyFormData.append('buy_price', buy_price_input.value);
    bodyFormData.append('sl_price', sl_price_input.value);



    bodyFormData.append('action', 'insert');
    bodyFormData.append('ID', store.get('yamasha_master_data').ID);
    bodyFormData.append('TOKEN', store.get('yamasha_master_data').TOKEN);
    axios.post(api_base + 'advisory.php', bodyFormData)
        .then(function (response) {
            btnLoading(insert_btn, 'Loading...', false);
            const res = response.data;
            console.log(res);
            if (res.status === 0) {
                Toast.fire({
                    icon: 'error',
                    title: res.msg
                });
            }
            if (res.status === 1) {
                Toast.fire({
                    icon: 'success',
                    title: res.msg
                });
                location.reload();
            }
            if (res.status === -1) {
                logOut();
            }
        })
        .catch(function (error) {
            console.log(error);
        });

}




function fetch_advisory_fun() {
    var bodyFormData = new URLSearchParams();
    bodyFormData.append('action', 'get');
    bodyFormData.append('ID', store.get('yamasha_master_data').ID);
    bodyFormData.append('TOKEN', store.get('yamasha_master_data').TOKEN);
    axios.post(api_base + 'advisory.php', bodyFormData)
        .then(function (response) {
            const res = response.data;
            console.log(res);
            if (res.status === 0) {
                Toast.fire({
                    icon: 'error',
                    title: res.msg
                });
            }
            if (res.status === 1) {
                // console.log(res.res_data[0]);
                // adding data to table
                let i = 0;
                while (res.res_data.length > i) {
                    // let   init_data = res.res_data[i]
                    const time = moment(res.res_data[i].TIME * 1000).startOf().fromNow();
                    data_table_body.innerHTML += ` 
                                    <tr>
                                           <th scope="row">${res.res_data[i].INDEX}</th>
                                        <td>${res.res_data[i].COMPANY_NAME}</td>
                                        <td>${res.res_data[i].CATEGORY}</td>
                                        <td>${res.res_data[i].MESSAGE}</td>
                                        <td>${res.res_data[i].BUY_PRICE}</td>
                                        <td>${res.res_data[i].SL_PRICE}</td>
                                        <td>${time}</td>
                                      
                                     
                                    
                                        <td> <button id="d${res.res_data[i].SN}" onclick="delete_advisory_fun(${res.res_data[i].SN})" class="btn btn-danger ">Delete</button> </td>
                                   </tr>`;
                    i++;
                }

                // Initiate Datatables


                // eslint-disable-next-line no-unused-vars
                const simpleDatatables = new DataTable('#data_table', {
                    // searchable: false,
                    // perPageSelect: false, 


                });
            }
            if (res.status === -1) {
                logOut();
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}


function delete_advisory_fun(SN) {
    btnLoading(byId('d' + SN), 'Deleting....', true);
    var bodyFormData = new URLSearchParams();
    bodyFormData.append('action', 'delete');
    bodyFormData.append('SN', SN);
    bodyFormData.append('ID', store.get('yamasha_master_data').ID);
    bodyFormData.append('TOKEN', store.get('yamasha_master_data').TOKEN);
    axios.post(api_base + 'advisory.php', bodyFormData)
        .then(function (response) {
            btnLoading(byId('d' + SN), 'Deleting....', false);
            const res = response.data;
            console.log(res);
            if (res.status === 0) {
                Toast.fire({
                    icon: 'error',
                    title: res.msg
                });
            }
            if (res.status === 1) {
                Toast.fire({
                    icon: 'success',
                    title: res.msg
                });
                location.reload();
            }
            if (res.status === -1) {
                logOut();
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}







